module.exports = __webpack_public_path__ + "static/media/placeholder.1f25c33e.png";